// extracted by mini-css-extract-plugin
export default {"bar":"SessionEnding_bar__GLc0x","clock":"SessionEnding_clock__-0IST"};